import "./Header.css";

function Header() {
  return (
    <header className="header_content">
      <a href="/">
        <h1 className="header_text">Catpedia</h1>
      </a>
    </header>
  );
}

export default Header;
